import { Component } from '@angular/core';

@Component({
  selector: 'uni-filters',
  templateUrl: './uni-filters.component.html',
  styleUrls: ['./uni-filters.component.scss'],
})
export class UniFiltersComponent {}
